import { combineReducers } from 'redux';
import { myTeamBackoffice } from '../views/MyTeamBackoffice/MyTeamBackoffice.reducer';
import auth from '../slices/auth-slice';
import kyc from '../slices/kyc-slice';
import accounting from '../slices/accounting-slice';
import orders from '../slices/orders-slice';
import contentBlock from '../slices/content-block-slice';
import notifications from '../slices/notifications-slice';
import helpDesk from '../slices/help-desk-slice';
import dashboard from '../slices/dashboard-slice';
import earnings from '../slices/earnings-slice';
import withdraw from '../slices/withdraw-slice';
import portfolio from '../slices/portfolio-slice';
import marketplace from '../slices/marketplace-slice';

import wallets from '../slices/wallets-slice';
import settings from '../slices/settings-slice';

import supportTickets from '../slices/support-tickets-slice';

export const reducers = combineReducers({
  auth,
  kyc,
  accounting,
  orders,
  contentBlock,
  notifications,
  helpDesk,
  dashboard,

  earnings,
  portfolio,
  withdraw,
  marketplace,

  wallets,
  settings,

  supportTickets,
  // old
  myTeamBackoffice
});

export type AppState = ReturnType<typeof reducers>;
